import { MAG7_SPACEX_PORTFOLIO_HREF } from "~/features/campaigns/campaign-data";
import { MAG7_CAMPAIGN_IMAGES } from "~/features/campaigns/mag7-campaign-assets.generated";
import {
  STRATEGY_PARTNER_IMAGES,
  type CampaignImageAsset,
} from "~/features/strategy-partner/data/strategy-partner-assets.generated";

export type StrategyPartnerPortfolioStatus = "active" | "coming-soon";

export type StrategyPartnerPortfolioId = "mag7x" | "robotics" | "us-ai-leaders";

export interface StrategyPartnerPortfolio {
  readonly artwork: CampaignImageAsset;
  readonly id: StrategyPartnerPortfolioId;
  readonly status: StrategyPartnerPortfolioStatus;
  /** Card click target; portfolios without one render inert. */
  readonly strategyHref?: string;
}

export interface StrategyPartnerDefinition {
  readonly cover: CampaignImageAsset;
  readonly portfolios: readonly StrategyPartnerPortfolio[];
  readonly slug: string;
  /* i18n-exempt: domain names are fixed identifiers. */
  readonly websiteHref: string;
  readonly websiteLabel: string;
  readonly wordmark: {
    readonly height: number;
    readonly path: string;
    readonly width: number;
  };
}

export const BITWISE_STRATEGY_PARTNER: StrategyPartnerDefinition = {
  cover: STRATEGY_PARTNER_IMAGES.bitwiseCover,
  portfolios: [
    {
      artwork: MAG7_CAMPAIGN_IMAGES["spacex-space"],
      id: "mag7x",
      status: "active",
      strategyHref: MAG7_SPACEX_PORTFOLIO_HREF,
    },
    {
      artwork: STRATEGY_PARTNER_IMAGES.bitwiseRobotics,
      id: "robotics",
      status: "coming-soon",
    },
    {
      artwork: STRATEGY_PARTNER_IMAGES.bitwiseUsAiLeaders,
      id: "us-ai-leaders",
      status: "coming-soon",
    },
  ],
  slug: "bitwise",
  websiteHref: "https://bitwiseinvestments.com",
  websiteLabel: "bitwiseinvestments.com",
  wordmark: {
    height: 56,
    path: "/assets/logos/bitwise_wordmark.svg",
    width: 257,
  },
};

const STRATEGY_PARTNERS: readonly StrategyPartnerDefinition[] = [
  BITWISE_STRATEGY_PARTNER,
];

export function getStrategyPartner(
  slug: string,
): StrategyPartnerDefinition | undefined {
  const normalizedSlug = slug.trim().toLowerCase();

  return STRATEGY_PARTNERS.find((partner) => partner.slug === normalizedSlug);
}
